import type { StandsKeys } from '@packages/config/Stands';
import { getCurrentStand } from '@packages/config/utils/getCurrentStand';
import { authorizationRoutes } from './authorization';
const stand = getCurrentStand();
const mvpHostUrls: { [key in StandsKeys]: string } = {
	test: 'https://lk.efrtest.ru',
	cert: 'https://lk.efrcert.ru',
	prod: 'https://lk.efr.ru',
};
const mvpHost = mvpHostUrls[stand];
export const routesConfig = {
	root: {
		absolutePath: window.rootPath,
		profile: {
			absolutePath: '/profile',
		},
		showcase: {
			absolutePath: '/showcase',
		},
		mvpLogin: {
			absolutePath: `${mvpHost}/login`,
		},
		...authorizationRoutes,
	},
};
